import React, { memo } from 'react';
export function BonusSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-69">
      <div className="max-w-5xl mx-auto" data-id="element-70">
        <div className="text-center mb-6" data-id="element-71">
          <h2 className="text-[20px] font-black mb-2 text-[#5A3FA0]" data-id="element-72">
            ADEMÁS RECIBÍS ESTOS BONUS
          </h2>
          <h3 className="text-2xl md:text-3xl font-bold text-gray-600 mb-4" data-id="element-73"></h3>
          <div className="inline-block bg-red-600 text-white text-xl md:text-2xl font-black px-8 py-3 rounded-full shadow-lg animate-bounce" data-id="element-74">
            🎁 GRATIS POR EL DÍA DE HOY
          </div>
        </div>

        <div className="space-y-6" data-id="element-75">
          {/* Bonus 1 */}
          <div className="flex flex-col md:flex-row items-center gap-5 bg-gray-50 rounded-3xl p-5 border border-gray-200" data-id="element-76">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-77">
              <img src="https://cdn.magicpatterns.com/uploads/dS8mwrgUp8LQYy8oeRkX3X/bonus_1.png" alt="Banco de Producciones Escritas" className="w-[400px] h-[400px] object-contain drop-shadow-xl" data-id="element-78" />
            </div>
            <div className="w-full md:w-1/2" data-id="element-79">
              <h3 className="text-3xl font-black mb-2 text-blue-600" data-id="element-80">
                🎁 BONUS 1 – Banco de Producciones Escritas
              </h3>
              <p className="text-xl font-bold mb-2" data-id="element-81">
                30 propuestas para pensar, argumentar y escribir.
              </p>
              <p className="text-lg mb-2" data-id="element-82">Incluye actividades sobre:</p>
              <ul className="space-y-1 text-lg mb-3 pl-4" data-id="element-83">
                <li className="flex items-center" data-id="element-84">
                  <span className="text-blue-500 mr-2" data-id="element-85">•</span> identidad
                </li>
                <li className="flex items-center" data-id="element-86">
                  <span className="text-blue-500 mr-2" data-id="element-87">•</span> ciudadanía
                </li>
                <li className="flex items-center" data-id="element-88">
                  <span className="text-blue-500 mr-2" data-id="element-89">•</span> democracia
                </li>
                <li className="flex items-center" data-id="element-90">
                  <span className="text-blue-500 mr-2" data-id="element-91">•</span> ambiente
                </li>
                <li className="flex items-center" data-id="element-92">
                  <span className="text-blue-500 mr-2" data-id="element-93">•</span> tecnología
                </li>
                <li className="flex items-center" data-id="element-94">
                  <span className="text-blue-500 mr-2" data-id="element-95">•</span> convivencia
                </li>
                <li className="flex items-center" data-id="element-96">
                  <span className="text-blue-500 mr-2" data-id="element-97">•</span> memoria
                </li>
                <li className="flex items-center" data-id="element-98">
                  <span className="text-blue-500 mr-2" data-id="element-99">•</span> cultura
                </li>
              </ul>
              <p className="text-lg font-medium italic p-2 rounded-lg bg-[#F9FAFB]" data-id="element-100">
                Ideal para trabajar producción escrita durante todo el año.
              </p>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="flex flex-col md:flex-row-reverse items-center gap-5 bg-gray-50 rounded-3xl p-5 border border-gray-200" data-id="element-101">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-102">
              <img src="https://cdn.magicpatterns.com/uploads/9jsSnCAnuKs5WQapCjUvLU/bonus_2.png" alt="Banco de Debates para Secundaria" className="w-[400px] h-[400px] object-contain drop-shadow-xl" data-id="element-103" />
            </div>
            <div className="w-full md:w-1/2" data-id="element-104">
              <h3 className="text-3xl font-black mb-2 text-blue-600" data-id="element-105">
                🎁 BONUS 2 – Banco de Debates para Secundaria
              </h3>
              <p className="text-xl font-bold mb-2" data-id="element-106">
                Temas actuales para dialogar, reflexionar y participar.
              </p>
              <p className="text-lg mb-2" data-id="element-107">Incluye debates sobre:</p>
              <ul className="space-y-1 text-lg mb-3 pl-4" data-id="element-108">
                <li className="flex items-center" data-id="element-109">
                  <span className="text-blue-500 mr-2" data-id="element-110">•</span> inteligencia
                  artificial
                </li>
                <li className="flex items-center" data-id="element-111">
                  <span className="text-blue-500 mr-2" data-id="element-112">•</span> redes sociales
                </li>
                <li className="flex items-center" data-id="element-113">
                  <span className="text-blue-500 mr-2" data-id="element-114">•</span> democracia
                </li>
                <li className="flex items-center" data-id="element-115">
                  <span className="text-blue-500 mr-2" data-id="element-116">•</span> ambiente
                </li>
                <li className="flex items-center" data-id="element-117">
                  <span className="text-blue-500 mr-2" data-id="element-118">•</span> educación
                </li>
                <li className="flex items-center" data-id="element-119">
                  <span className="text-blue-500 mr-2" data-id="element-120">•</span> tecnología
                </li>
                <li className="flex items-center" data-id="element-121">
                  <span className="text-blue-500 mr-2" data-id="element-122">•</span> convivencia
                </li>
                <li className="flex items-center" data-id="element-123">
                  <span className="text-blue-500 mr-2" data-id="element-124">•</span> cultura
                </li>
              </ul>
              <p className="text-lg font-medium italic p-2 rounded-lg bg-[#F9FAFB]" data-id="element-125">
                Listo para usar en cualquier curso.
              </p>
            </div>
          </div>

          {/* Bonus 3 */}
          <div className="flex flex-col md:flex-row items-center gap-5 bg-gray-50 rounded-3xl p-5 border border-gray-200" data-id="element-126">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-127">
              <img src="https://cdn.magicpatterns.com/uploads/9z9LYLqUtWdKTBybRcSxUS/bonus_3.png" alt="50 Actividades de Ciudadanía" className="w-[400px] h-[400px] object-contain drop-shadow-xl" data-id="element-128" />
            </div>
            <div className="w-full md:w-1/2" data-id="element-129">
              <h3 className="text-3xl font-black mb-2 text-blue-600" data-id="element-130">
                🎁 BONUS 3 – 50 Actividades de Ciudadanía
              </h3>
              <p className="text-xl font-bold mb-2" data-id="element-131">
                Recursos listos para trabajar:
              </p>
              <ul className="space-y-1 text-lg mb-3 pl-4" data-id="element-132">
                <li className="flex items-center" data-id="element-133">
                  <span className="text-blue-500 mr-2" data-id="element-134">•</span> participación
                  ciudadana
                </li>
                <li className="flex items-center" data-id="element-135">
                  <span className="text-blue-500 mr-2" data-id="element-136">•</span> democracia
                </li>
                <li className="flex items-center" data-id="element-137">
                  <span className="text-blue-500 mr-2" data-id="element-138">•</span> convivencia
                </li>
                <li className="flex items-center" data-id="element-139">
                  <span className="text-blue-500 mr-2" data-id="element-140">•</span> diversidad
                </li>
                <li className="flex items-center" data-id="element-141">
                  <span className="text-blue-500 mr-2" data-id="element-142">•</span> derechos humanos
                </li>
                <li className="flex items-center" data-id="element-143">
                  <span className="text-blue-500 mr-2" data-id="element-144">•</span> ambiente
                </li>
                <li className="flex items-center" data-id="element-145">
                  <span className="text-blue-500 mr-2" data-id="element-146">•</span> ciudadanía
                  digital
                </li>
                <li className="flex items-center" data-id="element-147">
                  <span className="text-blue-500 mr-2" data-id="element-148">•</span> solidaridad
                </li>
              </ul>
              <p className="text-lg font-medium italic p-2 rounded-lg bg-[#F9FAFB]" data-id="element-149">
                Ideal para tutorías, proyectos y jornadas escolares.
              </p>
            </div>
          </div>

          {/* Bonus 4 */}
          <div className="flex flex-col md:flex-row-reverse items-center gap-5 bg-gray-50 rounded-3xl p-5 border border-gray-200" data-id="element-150">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-151">
              <img src="https://cdn.magicpatterns.com/uploads/tejSKTZ6CiUS9NCBRaTtRn/bonus_4.png" alt="Del Aula al Mundo" className="w-[400px] h-[400px] object-contain drop-shadow-xl" data-id="element-152" />
            </div>
            <div className="w-full md:w-1/2" data-id="element-153">
              <h3 className="text-3xl font-black mb-2 text-blue-600" data-id="element-154">
                🎁 BONUS 4 – Del Aula al Mundo
              </h3>
              <p className="text-xl font-bold mb-2" data-id="element-155">
                Temas actuales para pensar el presente.
              </p>
              <p className="text-lg mb-2" data-id="element-156">Incluye:</p>
              <ul className="space-y-1 text-lg mb-3 pl-4" data-id="element-157">
                <li className="flex items-center" data-id="element-158">
                  <span className="mr-2" data-id="element-159">🌎</span> Inteligencia Artificial
                </li>
                <li className="flex items-center" data-id="element-160">
                  <span className="mr-2" data-id="element-161">🌎</span> Redes Sociales
                </li>
                <li className="flex items-center" data-id="element-162">
                  <span className="mr-2" data-id="element-163">🌎</span> Noticias Falsas
                </li>
                <li className="flex items-center" data-id="element-164">
                  <span className="mr-2" data-id="element-165">🌎</span> Salud Mental
                </li>
                <li className="flex items-center" data-id="element-166">
                  <span className="mr-2" data-id="element-167">🌎</span> Cambio Climático
                </li>
                <li className="flex items-center" data-id="element-168">
                  <span className="mr-2" data-id="element-169">🌎</span> Participación Juvenil
                </li>
                <li className="flex items-center" data-id="element-170">
                  <span className="mr-2" data-id="element-171">🌎</span> Diversidad
                </li>
                <li className="flex items-center" data-id="element-172">
                  <span className="mr-2" data-id="element-173">🌎</span> Profesiones del Futuro
                </li>
              </ul>
              <p className="text-lg font-medium italic p-2 rounded-lg bg-[#F9FAFB]" data-id="element-174">
                Un recurso moderno pensado para conectar la escuela con los
                desafíos actuales.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}